// ============================================================
//  Traducciones en español — es.ts
// ============================================================

const es = {

  common: {
    save:        "Guardar cambios",
    saving:      "Guardando...",
    loading:     "Cargando...",
    cancel:      "Cancelar",
    confirm:     "Confirmar",
    delete:      "Eliminar",
    edit:        "Editar",
    back:        "Volver",
    search:      "Buscar",
    noResults:   "Sin resultados",
    error:       "Algo salió mal",
    success:     "Operación exitosa",
    copyEmail:   "Copiar correo",
    copied:      "¡Copiado!",
    yes: "Sí",
no: "No",
  },

  nav: {
  dashboard: "Panel",
  members: "Miembros",
  users: "Usuarios",
  admins: "Administradores",
  accountants: "Contables",
  clients: "Clientes",
  expenses: "Notas de gastos",
  categories: "Categorías",
  offices: "Oficinas",
  companyPolicies: "Políticas de empresa",
  corporate: "Empresa",
  settings: "Configuración",
    openMenu: "Abrir menú",
notacitoLogo: "Logo de Notacito",
  account: "Mi cuenta",
  manageSubscription: "Gestionar suscripción",
  logout: "Cerrar sesión",
  help: "Ayuda",

  profileOverview: "Vista del perfil",
  options: "Opciones",
  defaultUser: "Usuario",

  expandMenu: "Ampliar menú",
  collapseMenu: "Reducir menú",

  plusDescription:
    "Desbloquea todas las funciones de administración.",
  viewOffer: "Ver oferta",
},

  account: {
    pageTitle:          "Gestionar mi cuenta",
    sidebarLabel:       "Gestionar mi cuenta",
    myAccount:          "Mi cuenta",
    security:           "Seguridad",
    manageSubscription: "Gestionar suscripción",
    myProfile:          "Mi perfil",
    firstName:          "Nombre",
    lastName:           "Apellido",
    myEmail:            "Mi correo",
    verified:           "✓ VERIFICADO",
    phone:              "Teléfono",
    phonePlaceholder:   "+34 600 000 000",
    toastSuccess:       "¡Perfil actualizado!",
    toastError:         "Error: ",
  },

  preferences: {
    title:      "Preferencias",
    language:   "Idioma",
    theme:      "Tema",
    lightMode:  "Modo claro",
    darkMode:   "Modo oscuro",
  },

  security: {
    title:        "Seguridad",
    description:  "Gestiona la seguridad de tu cuenta de administrador.",
    password:     "Contraseña",
    lastModified: "Última modificación: desconocida",
    dangerZone:   "Zona de peligro",
    dangerDesc:   "Acciones irreversibles en tu cuenta.",
    logout:       "Cerrar sesión",
  },

  subscription: {
    title:          "Mi suscripción",
    description:    "Gestiona tu plan y opciones de facturación.",
    freePlanDesc:   "Estás en el plan gratuito. Actualiza a Notacito Plus para desbloquear todas las funciones.",
    activePlanDesc: "Tu suscripción está activa. ¡Gracias por tu confianza!",
    upgradeCta:     "⭐ Pasar a Plus",
    status:         "Estado",
    plan:           "Plan",
    plans: {
      free:       "Gratuito",
      essential:  "Esencial",
      pro:        "Pro",
      enterprise: "Empresa",
    },
  },

  dashboard: {
    title:            "Panel",
    subtitle:         "Resumen de las estadísticas clave y la actividad financiera.",
    loading:          "Cargando datos del panel...",
    errorLoading:     "Error al cargar los datos. Inténtalo de nuevo.",
    totalMembers:     "Total Miembros",
    activeCategories: "Categorías Activas",
    expenseReports:   "Notas de Gastos",
    chartByType:      "Distribución por Tipo",
    chartByUsers:     "Distribución de Usuarios",
    chartByStatus:    "Estados de Notas de Gastos",
    chartOverTime:    "Evolución de los gastos (€)",
    tooltipAmount:    "{b} : {c} €",
    unknownRole:      "Desconocido",
    unknownStatus:    "UNKNOWN",
  },

  home: {
    title: "Usuarios",
    subtitle: "Gestiona todos los usuarios, agrupados por empresa.",
    totalUsers: "Total usuarios",
    companies: "Empresas",
    active: "Activo",
    blocked: "Bloqueado",
    left: "Se fue",
    searchPlaceholder: "Buscar por nombre, correo, rol…",
    noUsersFound: "No se encontraron usuarios.",
    noSearchMatch: "Ningún usuario coincide con tu búsqueda.",
    failedToLoad: "Error al cargar los usuarios:",
    userStatusUpdated: "Estado del usuario actualizado.",
    blockUser: "Bloquear usuario",
    activateUser: "Activar usuario",
    usersCount: "usuario",
    usersCountPlural: "usuarios",
    table: {
      name: "Nombre",
      email: "Correo",
      role: "Rol",
      phone: "Teléfono",
      status: "Estado",
      access: "Acceso"
    },
    page: "Página"
  },

  users: {
    unnamed: "Sin nombre",
    edit: "Editar",
    uid: "Firebase UID",
    copyUid: "Copiar UID",
    phone: "Teléfono",
    company: "Empresa",
    role: "Rol",
    iban: "IBAN",
    gender: "Género",
    birthDate: "Fecha de nacimiento",
    address: "Dirección",
    loading: "Cargando usuario...",
    errorLoading: "Error: ",
    notFound: "Usuario no encontrado.",
    cannotLoad: "No se pudo cargar el usuario.",
    client: "Cliente",
    accountant: "Contable",
    admin: "Admin",
    updated: "Usuario actualizado.",
    updateError: "Error al actualizar.",
    deleteConfirm: "¿Eliminar definitivamente a {name}?",
    deleted: "Usuario eliminado.",
    deleteError: "Error al eliminar.",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo",
    selectRole: "Selecciona un rol",
    selectGender: "Seleccionar",
    male: "Hombre",
    female: "Mujer",
    other: "Otro",
    deleting: "Eliminando...",
    deleteBtn: "Eliminar",
    cancelBtn: "Cancelar",
    saving: "Guardando...",
    saveBtn: "Guardar"
  },

  searchPlaceholderCompany: "Buscar por nombre, correo, empresa…",
  pagination: {
    result: "resultado",
    results: "resultados",
  },
  clients: {
    title: "Clientes",
    subtitle: "Gestiona tus clientes y su información.",
    addBtn: "Añadir Cliente",
    total: "Total clientes",
    block: "Bloquear cliente",
    activate: "Activar cliente",
    noMatch: "Ningún cliente coincide con tu búsqueda.",
    notFound: "No se encontraron clientes.",
    statusUpdated: "Estado del cliente actualizado.",
    failedToLoad: "Error al cargar los clientes:",
    count: "cliente",
    countPlural: "clientes",
  },
  accountants: {
    title: "Contables",
    subtitle: "Gestiona tus contables y su información.",
    addBtn: "Añadir Contable",
    total: "Total contables",
    block: "Bloquear contable",
    activate: "Activar contable",
    noMatch: "Ningún contable coincide con tu búsqueda.",
    notFound: "No se encontraron contables.",
    statusUpdated: "Estado del contable actualizado.",
    failedToLoad: "Error al cargar los contables:",
    count: "contable",
    countPlural: "contables",
  },
  admins: {
    title: "Administradores",
    subtitle: "Gestiona tus administradores y su información.",
    addBtn: "Añadir Admin",
    total: "Total admins",
    block: "Bloquear admin",
    activate: "Activar admin",
    noMatch: "Ningún admin coincide con tu búsqueda.",
    notFound: "No se encontraron administradores.",
    statusUpdated: "Estado del admin actualizado.",
    failedToLoad: "Error al cargar los administradores:",
    count: "admin",
    countPlural: "admins",
  },

  addUserForm: {
  roles: {
    client: {
      title: "Añadir cliente",
      create: "Crear cliente",
      success:
        "El cliente {name} se ha creado correctamente.",
      error:
        "Se ha producido un error al crear el cliente: {message}",
    },
    admin: {
      title: "Añadir administrador",
      create: "Crear administrador",
      success:
        "El administrador {name} se ha creado correctamente.",
      error:
        "Se ha producido un error al crear el administrador: {message}",
    },
    accountant: {
      title: "Añadir contable",
      create: "Crear contable",
      success:
        "El contable {name} se ha creado correctamente.",
      error:
        "Se ha producido un error al crear el contable: {message}",
    },
  },

  targetCompany: "Empresa de destino",
  platform: "Plataforma",
  noCompanies: "No hay empresas disponibles",

  firstName: "Nombre",
  lastName: "Apellido",
  email: "Correo electrónico",
  password: "Contraseña",
  phoneNumber: "Número de teléfono",
  optional: "opcional",

  placeholders: {
    firstName: "Introduce el nombre",
    lastName: "Introduce el apellido",
    email: "Introduce el correo electrónico",
    password: "Introduce la contraseña",
    phoneNumber: "Introduce el número de teléfono",
  },

  cancel: "Cancelar",
  creating: "Creando...",
  loading: "Cargando el formulario...",

  requiredFields:
    "Introduce el nombre, el apellido, el correo electrónico y la contraseña.",
  selectCompany:
    "Selecciona una empresa.",
  initializationError:
    "No se ha podido cargar la información necesaria para el formulario.",
  unknownError: "Error desconocido",
},

settingsForm: {
  pageTitle: "Configuración",

  gamification: {
    title: "⚙️ Gamificación",
    description:
      "Configura la clasificación de participación para las notas de gastos de tu equipo.",

    enabledLabel: "Activar la gamificación",
    enabledDescription:
      "Activa o desactiva la clasificación y la asignación de llamas.",

    deadlineLabel: "Día límite",
    deadlineDescription:
      "El día del mes en el que deben entregarse las notas de gastos, por ejemplo el día 10.",
  },

  saving: "Guardando...",
  saveChanges: "Guardar cambios",

  updateSuccess:
    "¡La configuración se ha actualizado correctamente!",
  updateError:
    "Error al actualizar la configuración: {message}",

  featureName: "la gestión de la gamificación",
},


 

  expenseReports: {
    title: "Notas de Gastos",
    subtitle: "Gestiona los gastos agrupados por empresa y empleado.",
    noCompany: "Sin empresa",
    unknownUser: "Desconocido",
    statusDraft: "Borrador",
    statusPending: "Pendiente",
    statusApproved: "Aprobado",
    statusReimbursed: "Reembolsado",
    statusRejected: "Rechazado",
    pendingAlertSingle: "gasto pendiente",
    pendingAlertPlural: "gastos pendientes",
    pendingLabel: "pendiente",
    approvedAlertSingle: "gasto aprobado",
    approvedAlertPlural: "gastos aprobados",
    approvedLabel: "aprobado",
    noAlerts: "Sin alertas",
    monthTotal: "Total del mes",
    noExpenses: "Sin gastos",
    reportCountSingle: "informe",
    reportCountPlural: "informes",
    userCountSingle: "usuario",
    userCountPlural: "usuarios",
    noExpensesThisMonth: "No hay gastos este mes.",
    showingExpensesFor: "Mostrando gastos de",
    only: "solamente",
    noUsersMatch: "Ningún usuario coincide con tu búsqueda.",
    showingSearchMatch: "Mostrando los gastos de este mes para los usuarios que coinciden con",
    noReportsFound: "No se encontraron notas de gastos.",
    tableSupplier: "Proveedor",
    tableCategory: "Categoría",
    tableDate: "Fecha",
    tableAmount: "Importe",
    tableVat: "IVA",
    tableStatus: "Estado",
    statTotalReports: "Total informes",
    statCompanies: "Empresas",
    statMonthTotal: "Total del mes",
    statPending: "Pendiente",
    statApproved: "Aprobado",
    statReimbursed: "Reembolsado",
    searchPlaceholder: "Buscar por nombre o correo → muestra sus gastos mensuales",
    failedToLoad: "Error al cargar las notas de gastos:",
    filterTitle:          "Filtrar",
    filterClear:          "Restablecer",
    filterAll:            "Todos",
    filterYear:           "Año",
    filterMonth:          "Mes",
    filterCategory:       "Categoría",
    filterStatus:         "Estado",
  },

 expenseReportDetails: {
  title: "Nota de gastos",

  loading: "Cargando la nota de gastos...",

  errors: {
    generic: "Error: {message}",
    notFound: "Nota de gastos no encontrada.",
    attachmentsNotFound: "No se encontraron los justificantes.",
  },

  status: {
    draft: "Borrador",
    pending: "Pendiente",
    approved: "Aprobada",
    rejected: "Rechazada",
    reimbursed: "Reembolsada",
  },

  sections: {
    items: "Elementos de gasto",
    attachments: "Justificantes",
  },

  fields: {
    amount: "Importe",
    receiptNumber: "Número de recibo",
    expenseDate: "Fecha del gasto",
    vatAmount: "Importe del IVA",
    submittedAt: "Fecha de envío",
    comment: "Comentario",
    distance: "Distancia",
    vehiclePower: "Potencia del vehículo",
    vehicleType: "Tipo de vehículo",
    energyType: "Tipo de energía",
    mileageRateYear: "Año del baremo kilométrico",
    calculatedReimbursement: "Reembolso calculado",
    participants: "Participantes",
    company: "Empresa",
    user: "Usuario",
    category: "Categoría",
  },

  itemFields: {
    type: "Tipo",
    quantity: "Cantidad",
    unitAmountTtc: "Precio unitario con impuestos",
    totalAmountTtc: "Total con impuestos",
    vatRate: "Tipo de IVA",
    vatAmount: "Importe del IVA",
    amountHt: "Importe sin impuestos",
    vatRecoverable: "IVA recuperable",
  },

  actions: {
    approve: "Aprobar",
    reject: "Rechazar",
    markAsReimbursed: "Marcar como reembolsada",
    openFull: "Abrir en tamaño completo",
  },

  empty: {
    items: "No se encontró ningún elemento.",
    attachments: "No se encontró ningún justificante.",
  },

  attachments: {
    receiptAlt: "Justificante de la nota de gastos",
    loadingPreview: "Cargando la vista previa...",
  },

  confirm: {
    deleteReport:
      "¿Seguro que quieres eliminar esta nota de gastos?",
    deleteItem:
      "¿Seguro que quieres eliminar este elemento de gasto?",
    changeStatus:
      "¿Seguro que quieres cambiar el estado a «{status}»?",
  },

  alerts: {
    reportDeleted:
      "La nota de gastos se ha eliminado correctamente.",
    reportDeleteError:
      "No se ha podido eliminar la nota de gastos.",
    itemDeleted:
      "El elemento de gasto se ha eliminado correctamente.",
    itemDeleteError:
      "No se ha podido eliminar el elemento de gasto.",
    attachmentOpenError:
      "No se ha podido abrir el justificante.",
    statusUpdated:
      "La nota de gastos ahora está «{status}».",
    statusUpdateError:
      "No se ha podido actualizar el estado de la nota de gastos.",
  },

  fileSize: {
    bytes: "B",
    kilobytes: "KB",
    megabytes: "MB",
  },

  itemTypes: {
    meal: "Comida",
    transport: "Transporte",
    accommodation: "Alojamiento",
    mileage: "Indemnización por kilometraje",
    other: "Otro",
  },

  vehicleTypes: {
    car: "Coche",
    motorcycle: "Motocicleta",
    scooter: "Escúter",
    bicycle: "Bicicleta",
  },

  energyTypes: {
    petrol: "Gasolina",
    gasoline: "Gasolina",
    diesel: "Diésel",
    electric: "Eléctrico",
    hybrid: "Híbrido",
    lpg: "GLP",
  },
},

editExpenseReport: {
  title: "Editar la nota de gastos",
  subtitle: "Actualiza la información de la nota de gastos.",

  fields: {
    supplierName: "Nombre del proveedor",
    receiptNumber: "Número del justificante",
    expenseDate: "Fecha del gasto",
    comment: "Comentario",
    distanceKm: "Distancia (km)",
    vehiclePowerCv: "Potencia del vehículo (CV)",
    vehicleType: "Tipo de vehículo",
    energyType: "Tipo de energía",
    mileageRateYear: "Año del baremo kilométrico",
    participantCount: "Número de participantes",
  },

  placeholders: {
    supplierName: "Nombre del proveedor",
    receiptNumber: "Número del justificante",
    optionalComment: "Comentario opcional",
    vehicleType: "COCHE, MOTO...",
    energyType: "GASOLINA, ELÉCTRICO...",
    mileageRateYear: "2026",
    zero: "0",
  },

  cancel: "Cancelar",
  saving: "Guardando...",
  saveChanges: "Guardar cambios",

  success: "La nota de gastos se ha actualizado correctamente.",
  error: "No se ha podido actualizar la nota de gastos.",
},

officeDetailsCard: {
  structureType: "Tipo de estructura",
  platformSystem: "🛡️ Plataforma principal",
  clientCompany: "🏢 Empresa cliente",
  id: "Identificador",
  cancel: "Cancelar",
  deleteOffice: "Eliminar oficina",
  deleteConfirm:
    '¿Seguro que quieres eliminar la oficina «{name}»?',
  deleteSuccess: "La oficina se ha eliminado correctamente.",
  deleteError: "No se ha podido eliminar la oficina.",
},

addOffice: {
  title: "Añadir una nueva oficina",
  officeName: "Nombre de la oficina",
  officeNamePlaceholder:
    "Introduce el nombre de la empresa o del cliente",
  isMainPlatform:
    "¿Es esta la plataforma principal de Notacito?",
  cancel: "Cancelar",
  creating: "Creando...",
  createOffice: "Crear oficina",
  nameRequired: "El nombre de la oficina es obligatorio.",
  createSuccess: "La oficina se ha creado correctamente.",
  createError:
    "Error al crear la oficina: {message}",
},

categoryTypes: {
  standard: "Estándar",
  meal: "Comida",
  fuel: "Combustible",
  phone: "Teléfono",
  pressing: "Tintorería",
  equipment: "Equipamiento",
  officeSupply: "Material de oficina",
  other: "Otro",
},

categoryDetails: {
  unnamed: "Sin nombre",
  noCompany: "Sin empresa",
  cancel: "Cancelar",
  deleteCategory: "Eliminar categoría",
  editCategory: "Editar categoría",
  deleteConfirm:
    '¿Seguro que quieres eliminar la categoría «{name}»?',
  deleteSuccess:
    "La categoría se ha eliminado correctamente.",
  deleteError:
    "No se ha podido eliminar la categoría.",
},

patchCategory: {
  title: "Editar categoría",
  categoryType: "Tipo de categoría",
  loading: "Cargando...",
  cancel: "Cancelar",
  saving: "Guardando...",
  saveChanges: "Guardar cambios",
  fetchError:
    "Error al cargar la categoría.",
  updateSuccess:
    "La categoría se ha actualizado correctamente.",
  updateError:
    "Error al actualizar la categoría: {message}",
},

addCategory: {
  title: "Añadir una nueva categoría",
  targetCompany: "Empresa de destino",
  categoryType: "Tipo de categoría",
  platform: "Plataforma",
  cancel: "Cancelar",
  creating: "Creando...",
  createCategory: "Crear categoría",
  loading: "Cargando el formulario...",
  selectCompany:
    "Selecciona una empresa de destino.",
  requirementsError:
    "No se ha podido cargar la información necesaria para el formulario.",
  createSuccess:
    "La categoría se ha creado correctamente.",
  createError:
    "Error al crear la categoría: {message}",
},

categoriesPage: {
  title: "Categorías",

  accountantSubtitle:
    "Consulta las categorías disponibles para tu empresa.",
  managementSubtitle:
    "Gestiona tus categorías y su información.",

  addCategory: "Añadir categoría",

  totalCategories: "Total de categorías",
  companiesAffected: "Empresas afectadas",

  searchPlaceholder:
    "      Buscar categorías por tipo o nombre...",

  noCategories: "No se encontraron categorías.",
  noSearchMatch:
    "Ninguna categoría coincide con tu búsqueda.",

  noCompany: "Global / Sin empresa",

  typeName: "Tipo / Nombre",

  categorySingle: "categoría",
  categoryPlural: "categorías",

  page: "Página",

  loadingError:
    "No se han podido cargar las categorías: {message}",
  unknownError: "Error desconocido",

  featureName: "la gestión de categorías",
},



editExpenseReportItem: {
  title: "Editar elemento de gasto",
  subtitle: "Actualiza la información del elemento de gasto.",

  fields: {
    label: "Nombre",
    itemType: "Tipo de gasto",
    quantity: "Cantidad",
    unitAmountTtc: "Importe unitario con impuestos",
    totalAmountTtc: "Total con impuestos",
    vatRate: "Tipo de IVA",
    vatAmount: "Importe del IVA",
    amountHt: "Importe sin impuestos",
    vatRecoverable: "IVA recuperable",
    comment: "Comentario",
  },

  itemTypes: {
    standard: "Estándar",
    meal: "Comida",
    fuel: "Combustible",
    phone: "Teléfono",
    pressing: "Tintorería",
    equipment: "Equipamiento",
    officeSupply: "Material de oficina",
    other: "Otro",
  },

  yes: "Sí",
  no: "No",
  cancel: "Cancelar",
  saving: "Guardando...",
  save: "Guardar elemento",

  success: "El elemento de gasto se ha actualizado correctamente.",
  error: "No se ha podido actualizar el elemento de gasto.",
},


  offices: {
    title: "Oficinas",
    subtitle: "Gestiona las oficinas de tu empresa",
    loading: "Cargando oficinas...",
    errorLoading: "Error al cargar las oficinas:",
    noOffices: "No hay oficinas disponibles.",
    addBtn: "Añadir Oficina",
  },

  officeCell: {
    noName: "Sin nombre",
    mainPlatform: "Plataforma Principal",
    standardCorporate: "Corporativo Estándar",
  },
  officeDetails: {
    loading: "Cargando detalles de la oficina...",
    errorPrefix: "Error: ",
    notFound: "Oficina no encontrada.",
  },

  companyPolicies: {
    title: "Políticas de Empresa",
    loading: "Cargando políticas...",
    deleteSuccess: "Política eliminada con éxito",
    deleteConfirm: "¿Estás seguro de que deseas eliminar esta política?",
    addBtn: "Añadir Política",
    deleting: "Eliminando...",
    deleteBtn: "Eliminar Política",
    editBtn: "Editar Reglas",
    status: "Estado",
    dailyLimit: "Límite Diario",
    vatRule: "Regla de IVA",
    receiptRequired: "Recibo Obligatorio",
    manualVat: "IVA Manual",
    active: "Activa",
    allowed: "Permitido ✅",
    forbidden: "Prohibido ❌",
    noLimit: "Sin límite",
    yes: "Sí",
    no: "No",
    selectCategory: "Selecciona una categoría para ver los detalles.",
    featureName: "la gestión de políticas de empresa",
  },

  companyPolicyForm: {
  editTitle: "Editar la política",
  editSubtitle:
    "Ajusta los límites y requisitos para esta categoría de gasto.",

  createTitle: "Crear una nueva política",
  createSubtitle:
    "Configura una nueva regla de gastos para tu empresa.",

  loading: "Cargando...",

  fields: {
    category: "Seleccionar una categoría",
    spendingLimit: "Límite de gasto (€)",
    maxWithoutReceipt: "Máximo sin justificante (€)",
    vatRuleType: "Tipo de regla de IVA",
    status: "Estado",
  },

  placeholders: {
    chooseCategory: "Elegir una categoría",
    noLimit: "Sin límite",
    zero: "0",
  },

  vatRules: {
    none: "Ninguna",
    manual: "Manual",
    sumLines: "Suma de líneas",
  },

  statuses: {
    active: "Activa",
    inactive: "Inactiva",
  },

  conditionsTitle: "Condiciones y justificantes",

  conditions: {
    allowed: "Permitido",
    requiresReceipt: "Justificante obligatorio",
    allowsVat: "IVA permitido",
    allowsManualVat: "IVA manual permitido",
    requiresComment: "Comentario obligatorio",
    requiresSupplierName: "Nombre del proveedor obligatorio",
    allowsDistanceKm: "Kilometraje permitido",
    allowsFuelExpense: "Gasto de combustible",
    allowCompanyCar: "Vehículo de empresa",
    allowPersonalCar: "Vehículo personal",
  },

  cancel: "Cancelar",
  saving: "Guardando...",
  saveChanges: "Guardar cambios",
  creating: "Creando...",
  createPolicy: "Crear política",

  updateSuccess:
    "La política se ha actualizado correctamente.",
  updateError:
    "No se ha podido actualizar la política: {message}",
  createSuccess:
    "La política se ha creado correctamente.",
  createError:
    "No se ha podido crear la política: {message}",
  loadError: "No se ha podido cargar la política.",
  categoriesLoadError:
    "No se han podido cargar las categorías.",
},

  corporate: {
    loading: "Cargando estadísticas corporativas...",
    errorLoading: "Error al cargar las estadísticas. Inténtalo de nuevo.",
    title: "Compromiso Corporativo",
    subtitle: "Rastrea la puntualidad del equipo y el compromiso con los informes de gastos.",
    statActive: "Empleados Activos",
    statTopStreak: "Mejor Racha",
    statTotalFlames: "Total Llamas Equipo",
    liveLeaderboard: "🏆 Clasificación en Vivo",
    liveBadge: "En Vivo",
    noActiveParticipants: "No hay participantes activos aún.",
    historicalPodium: "📊 Podio Histórico",
    btnSnapshot: "📸 Guardar",
    btnSaving: "Guardando...",
    snapshotSuccess: "Foto de la clasificación guardada para",
    snapshotError: "Error al guardar:",
    snapshotConfirm: "¿Quieres congelar la clasificación actual para el mes {month}/{year}? Esto sobrescribirá el historial existente para este mes.",
    noDataRecorded: "No hay datos registrados para este mes.",
    howItWorksTitle: "💡 Cómo funciona",
    howItWorksL1: "Gana llamas: Los empleados ganan 1 llama máximo por mes al enviar sus gastos antes de la fecha límite.",
    howItWorksL2: "Penalizaciones: Perder una fecha límite resulta en la pérdida de 1 llama (¡no lo pierdes todo a la vez!).",
    howItWorksL3: "Hitos: Mantén la racha hasta un máximo de 12 llamas para desbloquear insignias (Bronce a 4, Plata a 8, Oro a 12).",
    howItWorksL4: "Historial: El podio se guarda el último día de cada mes.",
    chartTitle: "Top 10 del mes"
  },

  upgrade: {
  back: "Volver",
  ratingText: "La gestión de gastos simplificada",
  title: "Elige el plan adecuado para",
  titleHighlight: "tu empresa",
  subtitle:
    "Centraliza, valida y controla las notas de gastos de tus empleados desde una única plataforma.",

  monthly: "Mensual",
  yearly: "Anual",
  yearlyDiscount: "-10 %",

  mostPopular: "MÁS POPULAR",
  perMonth: "/ mes",
  billed: "Facturado",
  perYear: "al año",
  noPaymentRequired:
    "No se requiere método de pago",

  redirecting: "Redirigiendo...",
  continueFree: "Continuar gratis",
  choosePlan: "Elegir este plan",

  errors: {
    planNotConfigured:
      "Este plan aún no está configurado para el pago.",
    checkoutUrlMissing:
      "No se encontró la URL de pago.",
    checkoutFailed:
      "No se pudo abrir la página de pago. Inténtalo de nuevo.",
  },

  reassurance: {
    securePaymentTitle: "Pago seguro",
    securePaymentText:
      "Los pagos serán procesados por Stripe.",
    noCommitmentTitle: "Sin compromiso",
    noCommitmentText:
      "Podrás cancelar tu suscripción.",
    helpTitle: "¿Necesitas ayuda?",
    helpText:
      "Nuestro equipo te acompañará durante la instalación.",
  },

  plans: {
    free: {
      name: "Descubrimiento",
      description:
        "Descubre Notacito con acceso limitado a las funciones.",
      features: {
        employees: "Hasta 3 empleados",
        expenses: "5 notas de gastos al mes",
        manualCreation:
          "Creación manual de gastos",
        automaticScan:
          "Escaneo automático de recibos",
        validation:
          "Validación de notas de gastos",
        accountingExports:
          "Exportaciones contables",
        prioritySupport: "Soporte prioritario",
      },
    },

    essential: {
      name: "Esencial",
      description:
        "Para pequeñas empresas que desean centralizar sus gastos.",
      features: {
        employees: "Hasta 20 empleados",
        expenses:
          "20 notas por empleado y mes",
        automaticScan:
          "Escaneo automático de recibos",
        validation: "Flujo de validación",
        accountingExports:
          "Exportaciones contables",
        dashboard:
          "Panel de administración",
        emailSupport: "Soporte por correo",
      },
    },

    business: {
      name: "Business",
      description:
        "La solución completa para gestionar eficazmente los gastos de tu equipo.",
      features: {
        employees: "Hasta 50 empleados",
        expenses:
          "20 notas por empleado y mes",
        automaticScan:
          "Escaneo automático de recibos",
        advancedValidation:
          "Flujos de validación avanzados",
        accountingExports:
          "Exportaciones contables",
        roles:
          "Gestión de roles y permisos",
        prioritySupport: "Soporte prioritario",
      },
    },

    enterprise: {
      name: "Empresa",
      description:
        "Una solución adaptada a empresas con necesidades importantes.",
      features: {
        employees: "Hasta 500 empleados",
        expenses:
          "20 notas por empleado y mes",
        businessFeatures:
          "Todas las funciones Business",
        personalSupport:
          "Acompañamiento personalizado",
        bulkImport:
          "Importación masiva de empleados",
        customConfiguration:
          "Configuración personalizada",
        dedicatedSupport:
          "Soporte prioritario dedicado",
      },
    },
  },
},

notifications: {
  title: "Notificaciones",
  subtitle:
    "Gestiona tus alertas y la actividad de tu empresa.",

  markAllAsRead:
    "Marcar todo como leído",
  markingAllAsRead: "Actualizando...",
  close: "Cerrar y volver atrás",

  tabs: {
    all: "Todas",
    unread: "No leídas",
  },

  loading:
    "Cargando tus notificaciones...",

  emptyTitle: "No hay notificaciones",
  emptyMessage:
    "¡Estás al día! No hay nada que mostrar por el momento.",

  noUnreadTitle:
    "No hay notificaciones sin leer",
  noUnreadMessage:
    "Has leído todas tus notificaciones.",
},

 auth: {
    login:          "Iniciar sesión",
    loginTitle:     "Iniciar sesión",
    email:          "Correo electrónico",
    password:       "Contraseña",
    forgotPassword: "¿Olvidaste tu contraseña?",
    noAccount:      "¿No tienes cuenta?",
    register:       "Registrarse",
    loginError:     "Correo o contraseña incorrectos",
    or: "o",
    googleLogin: "Iniciar sesión con Google",
    signingIn: "Iniciando sesión...",
    subtitle: "Acceso restringido a administradores",
    noAdminAccess: "No tienes permiso para acceder al panel de administración.",
    profileError: "Error al obtener el perfil.",
    fillBothFields: "Por favor rellena los dos campos.",
    loginFailed: "Error al iniciar sesión.",
    incompleteUser: "La información del usuario está incompleta.",
    firebaseError: "Error de Firebase:",
    unknownError: "Se produjo un error",
  },

  errors: {
    required:     "Este campo es obligatorio",
    invalidEmail: "Correo inválido",
    networkError: "Error de red, inténtalo de nuevo",
    unauthorized: "Sesión expirada, inicia sesión de nuevo",
    notFound:     "Página no encontrada",
  },

};

export default es;